// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2PV5z","col":"styles_col__3Eey6","fulfillmentStatus":"styles_fulfillmentStatus__2Yfvp","emailCol":"styles_emailCol__FBdz-"};